import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form--single-submit" on a <form>.
//
// Turbo disables only the button that was clicked while a submission is in
// flight. The document builder's form has several (Vystaviť, Uložiť ako
// koncept, the mobile bar, the header's Vystaviť on a draft — most of them
// outside the form, joined to it by the `form` attribute), so "Vystaviť" then
// "Koncept" in quick succession created two documents, one of them issued.
// While a submission runs every other submit button of the form is disabled,
// and re-enabled when it ends (a validation error re-renders the form; a
// success navigates away).
//
// form.elements includes buttons associated through the `form` attribute.
export default class extends Controller {
  connect() {
    this.locked = []
  }

  disconnect() {
    this.unlock()
  }

  // Only this form's own submissions: turbo:submit-start/-end bubble, and the
  // builder hosts modal frames (contact, bank account, number series) whose
  // forms sit inside it.
  lock(event) {
    if (event.target !== this.element) return

    const submitter = event.detail?.formSubmission?.submitter
    const more = Array.from(this.element.elements).filter(
      (element) => element.type === "submit" && element !== submitter && !element.disabled
    )
    for (const element of more) element.disabled = true
    this.locked = this.locked.concat(more)
  }

  unlock(event) {
    if (event && event.target !== this.element) return

    for (const element of this.locked) element.disabled = false
    this.locked = []
  }
}
